module.exports = __webpack_public_path__ + "static/media/BlogWebsite.e9e0821c.png";